import { render, staticRenderFns } from "./AppRedirect.vue?vue&type=template&id=32489e08&scoped=true&"
import script from "./AppRedirect.vue?vue&type=script&lang=js&"
export * from "./AppRedirect.vue?vue&type=script&lang=js&"
import style0 from "./AppRedirect.vue?vue&type=style&index=0&id=32489e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32489e08",
  null
  
)

export default component.exports